import cn from 'classnames'
import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useCallback, useMemo } from 'react'

import { FormNumberInput, useGetFormDataField } from 'cng-common/features/form'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { getDemoUnitsInputLabelTranslation } from '../../helpers/getDemoUnitsInputLabelTranslation'

import styles from './DemoUnitsEditMode.module.scss'

interface IDemoUnitsEditModeProps {
  demoUnits: Nullable<number>
  isRetail?: boolean
  isDistributor?: boolean
}

const tooltipMessage = 'This value is required for completeness'
export const DemoUnitsEditMode: FC<IDemoUnitsEditModeProps> = ({
  demoUnits,
  isRetail,
  isDistributor,
}) => {
  const [formDemoUnits] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.demoUnits
  )

  const demoUnitsFieldLabelTranslation = useMemo(
    () =>
      getDemoUnitsInputLabelTranslation({
        isRetail,
        isDistributor,
      }),
    [isRetail, isDistributor]
  )

  const shouldShowCompletenessWarning = useCallback((currentValue: Nullable<number>) => {
    return currentValue === null
  }, [])

  const tooltipRender = useCallback(() => {
    return <>{tooltipMessage}</>
  }, [])

  const demoUnitsTooltipCondition = shouldShowCompletenessWarning(formDemoUnits) && !formDemoUnits

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <Tooltip disabled={!demoUnitsTooltipCondition} tipContent={tooltipRender}>
            <FormNumberInput
              formKey={PARTNER_BASIC_INFO_FORM_KEY}
              field={partnerBasicInfoFields.demoUnits}
              label={demoUnitsFieldLabelTranslation}
              defaultValue={demoUnits}
              className={cn({
                [styles.warning]: demoUnitsTooltipCondition,
              })}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
